export function formatReportDate(isoDate) {
  if (!isoDate) return '—';
  const d = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString(undefined, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
}

export function getPeriodDateRange(periodType) {
  const today = new Date();
  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  let start;

  switch (periodType) {
    case 'daily':
      start = new Date(end);
      break;
    case 'weekly': {
      start = new Date(end);
      const day = start.getDay();
      const diff = day === 0 ? 6 : day - 1;
      start.setDate(start.getDate() - diff);
      break;
    }
    case 'monthly':
    default:
      start = new Date(end.getFullYear(), end.getMonth(), 1);
      break;
  }

  const fmt = (d) => d.toISOString().slice(0, 10);
  return { date_from: fmt(start), date_to: fmt(end) };
}

export function hoursStatusLabel(status) {
  const key = (status || '').toLowerCase();
  if (key === 'overtime') return 'Overtime';
  if (key === 'underworked') return 'Underworked';
  return 'Normal';
}

export function hoursStatusClass(status) {
  const key = (status || '').toLowerCase();
  if (key === 'overtime') return 'ea-hr-status--over';
  if (key === 'underworked') return 'ea-hr-status--under';
  return 'ea-hr-status--normal';
}

export function getSummaryEarlyDays(row) {
  if (row == null) return 0;
  return Number(row.early_days ?? row.early ?? 0);
}

export function getSummaryOnTimeDays(row) {
  if (row == null) return 0;
  return Number(
    row.on_time_days ?? row.ontime_days ?? row.normal_days ?? row.on_time ?? 0
  );
}
